import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "Breadcrumb" }

import { withDefaults } from 'vue'
import { IBreadcrumb } from './types'

export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  props: {
    breadcrumbs: { default: () => [] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_breadcrumb, { separator: "/" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item) => {
          return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: item.name,
            to: { path: item.path }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})